import { makeStyles } from 'tss-react/mui';
export const useStyles = makeStyles()((theme) => ({
    MfaProviderLinkContainer: {
        textAlign: 'center'
    },
    CodeSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '180px'
    },
    StepButton: {
        width: '160px'
    },
    ToggleQrButton: {
        fontSize: '13px'
    },
    SecretInput: {
        maxWidth: '450px',
        '& textarea': {
            textAlign: 'center'
        }
    },
    InputErrorMessage: {
        color: theme.palette.error.main,
        marginTop: '8px',
        display: 'block'
    }
}));
//# sourceMappingURL=styles.js.map